import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
  NGX_MAT_DATE_FORMATS,
  NgxMatDateAdapter,
  NgxMatDateFormats,
} from '@nng-components/angular-material-datetime-picker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatOptionModule,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { enUS } from 'date-fns/locale';
import { CustomNgxDateFnsAdapter } from '@extensions/custom-ngx-date-fns-adapter';
import { MatRadioModule } from '@angular/material/radio';

// Remove the existing CUSTOM_DATE_FORMATS and define both formats:
const CUSTOM_NGX_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'M/d/yyyy, h:mm:ss a',
  },
  display: {
    dateInput: 'M/d/yyyy, h:mm:ss a',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MMMM d, yyyy, h:mm:ss a',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

const MATERIAL_DATE_FORMATS = {
  parse: {
    dateInput: 'M/d/yyyy',
  },
  display: {
    dateInput: 'M/d/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MMMM d, yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@NgModule({
  exports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatOptionModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    MatMenuModule,
    MatExpansionModule,
    MatTabsModule,
    MatDividerModule,
    MatTooltipModule,
    MatRadioModule,
    ScrollingModule,
    MatTreeModule,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: enUS,
    },
    {
      provide: MAT_DATE_FORMATS, // This for Material Datepicker
      useValue: MATERIAL_DATE_FORMATS,
    },
    {
      provide: NGX_MAT_DATE_FORMATS, // This is for NgxMatDatetimePicker
      useValue: CUSTOM_NGX_DATE_FORMATS,
    },
    {
      provide: NgxMatDateAdapter,
      useClass: CustomNgxDateFnsAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class AngularMatModule {}
